import React from 'react';
import { Link } from 'react-router-dom';
import { LinkedinIcon, InstagramIcon, FacebookIcon } from 'lucide-react';
import { useTranslation } from '../../lib/i18n';
// TikTok icon (not in lucide-react)
function TikTokIcon({
  className
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-333">
      <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.33 6.33 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.75a4.85 4.85 0 0 1-1.01-.06z" data-id="element-334" />
    </svg>;
}
export function Footer() {
  const {
    t,
    lang
  } = useTranslation();
  const socials = [{
    href: 'https://www.instagram.com/dtech.rs',
    icon: InstagramIcon,
    label: 'Instagram'
  }, {
    href: 'https://www.facebook.com/profile.php?id=61589561484063',
    icon: FacebookIcon,
    label: 'Facebook'
  }, {
    href: 'https://www.tiktok.com/@dtech_rs',
    icon: TikTokIcon,
    label: 'TikTok'
  }, {
    href: 'https://www.linkedin.com/company/115805045/',
    icon: LinkedinIcon,
    label: 'LinkedIn'
  }];
  return <footer className="bg-dark-surface border-t-2 border-dark-border mt-auto" data-id="element-335">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-336">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-337">
          <div data-id="element-338">
            <img src="https://cdn.magicpatterns.com/uploads/mrmC3EPvZ6yt8zBvajm1cp/LOGO_FINAL.jpg" alt="D-TECH Solutions" className="h-10 w-auto mb-4 rounded" data-id="element-339" />
            <p className="text-gray-400 text-sm leading-relaxed mb-4" data-id="element-340">
              {lang === 'en' ? 'Electric machines for safe cargo transport in multi-story buildings.' : lang === 'ru' ? 'Электрические машины для безопасной транспортировки грузов в многоэтажных зданиях.' : 'Električne mašine za bezbedan transport tereta u višespratnim objektima.'}
            </p>
            <div className="flex flex-col gap-2 mb-4 text-sm" data-id="element-341">
              <a href="mailto:info@dtech.rs" className="text-gray-400 hover:text-brand-yellow transition-colors" data-id="element-342">
                info@dtech.rs
              </a>
              <a href="tel:+381653312811" className="text-gray-400 hover:text-brand-yellow transition-colors" data-id="element-343">
                065 331 2811
              </a>
            </div>
            <div data-id="element-344">
              <p className="text-white font-bold text-sm mb-3" data-id="element-345">
                {lang === 'en' ? 'Follow us' : lang === 'ru' ? 'Подписывайтесь на нас' : 'Pratite nas'}
              </p>
              <div className="flex items-center gap-3 flex-wrap" data-id="element-346">
                {socials.map(({
                href,
                icon: Icon,
                label
              }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" aria-label={label} title={label} className="w-10 h-10 flex items-center justify-center rounded-industrial border border-dark-border bg-dark-bg text-gray-300 hover:text-dark-bg hover:bg-brand-yellow hover:border-brand-yellow transition-colors" data-id="element-347">
                    <Icon className="w-5 h-5" data-id="element-348" />
                  </a>)}
              </div>
            </div>
          </div>
          <div data-id="element-349">
            <h3 className="text-white font-bold mb-4" data-id="element-350">{t.footer.products}</h3>
            <ul className="space-y-2" data-id="element-351">
              <li data-id="element-352">
                <Link to="/products/sca" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-353">
                  D-TECH SCA (STANDARD)
                </Link>
              </li>
              <li data-id="element-354">
                <Link to="/products/standard" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-355">
                  D-TECH STANDARD (SCB 300)
                </Link>
              </li>
              <li data-id="element-356">
                <Link to="/products/standard-plus" className="text-gray-400 hover:text-white text-sm transition-colors flex items-center gap-2" data-id="element-357">
                  D-TECH STANDARD+ (SCB 300)
                  <span className="text-[9px] font-bold uppercase tracking-wider text-brand-yellow border border-brand-yellow/50 px-1.5 py-0.5 rounded" data-id="element-358">
                    {lang === 'en' ? 'Coming soon' : lang === 'ru' ? 'Скоро' : 'Uskoro'}
                  </span>
                </Link>
              </li>
              <li data-id="element-359">
                <Link to="/products/raptor" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-360">
                  D-TECH RAPTOR (SCB 300)
                </Link>
              </li>
            </ul>
          </div>
          <div data-id="element-361">
            <h3 className="text-white font-bold mb-4" data-id="element-362">{t.footer.company}</h3>
            <ul className="space-y-2" data-id="element-363">
              <li data-id="element-364">
                <Link to="/about" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-365">
                  {t.footer.about}
                </Link>
              </li>
              <li data-id="element-366">
                <Link to="/contact" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-367">
                  {t.footer.contact}
                </Link>
              </li>
              <li data-id="element-368">
                <Link to="/legal" className="text-gray-400 hover:text-white text-sm transition-colors" data-id="element-369">
                  {t.footer.legal}
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-dark-border pt-8 text-center" data-id="element-370">
          <p className="text-gray-500 text-sm" data-id="element-371">
            © {new Date().getFullYear()} D-TECH Solutions. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>;
}